import {states} from '@/constants/user-constants';
import {sexes} from '@/constants/global-constants';

export const getUserStatesOptions = () => {
    let array = [];
    Object.keys(states).forEach((key) => {
        array.push({
            value: key,
            text: states[key]
        });
    });
    return array;
};

export const getUserSexesOptions = () => {
    let array = [];
    Object.keys(sexes).forEach((key) => {
        array.push({
            value: key,
            text: sexes[key]
        });
    });
    return array;
};

export const getStatusByCode = (code) => (states[code]);

export const filterUsers = (users, departmentCode) => {
    return users.filter(user => !!user.department && user.department.code === departmentCode);
};
export const filterActiveUsers = (users) => {
    let array = [];
    users.forEach((value) => {
        if (value.status === 1 && (value.department.code === "COMERCIAL" || value.department.code === "ADMINISTRACION" || value.department.code === "GESTION SOCIOS")) {
          value.roles.forEach((role) => {
            if (role.name === "COMMERCIAL") {
              array.push(value)
            }
          });
        }
    });
    return array;
};
export const filterActiveStatusUsers = (users) => {
  let array = [];
  users.forEach((value) => {
    if (value.status === 1 && (value.department.code === "COMERCIAL")) {
      value.roles.forEach((role) => {
        if (role.name === "COMMERCIAL") {
          array.push(value)
        }
      });
    }
  });
  return array;
}
